import request from '@/utils/request';
// 获取卖点分析列表
export function getProductSellingPointApi(data) {
  return request({
    url: '/ecom/ai/getProductSellingPoint',
    method: 'post',
    data
  })
}
// 新增卖点分析
export function insertProductSellingPointApi(data) {
  return request({
    url: '/ecom/ai/insertProductSellingPoint',
    method: 'post',
    data
  })
}
// 修改卖点分析
export function updateProductSellingPointApi(data) {
  return request({
    url: '/ecom/ai/updateProductSellingPoint',
    method: 'post',
    data
  })
}